import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ccd6f6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lookup-container px-3" }
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = { class: "uix-control-container" }
const _hoisted_4 = { class: "uix-control-group" }
const _hoisted_5 = ["inputmode", "maxlength", "placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "uix-control-sm-label show"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Trailer Number", -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "toggleWrapper" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "typeToggle" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-color" }, "Trailer number contains letters", -1))
const _hoisted_12 = { class: "button-content" }
const _hoisted_13 = {
  key: 0,
  class: "scanner-disabled-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fbx_input_reset = _resolveComponent("fbx-input-reset")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.headLineText), 1),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.extraClass)
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              id: "trailer-input",
              inputmode: _ctx.isInputText ? 'search' : 'numeric',
              class: _normalizeClass(["uix-control-text", 
                                _ctx.trailerId || _ctx.hasAlert
                                    ? 'uix-control-text'
                                    : 'uix-control-text uix-control-text-center'
                            ]),
              maxlength: _ctx.maxLength,
              placeholder: `${_ctx.driverCompany} Trailer Number`,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trailerId) = $event)),
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scrollInputIntoView && _ctx.scrollInputIntoView(...args)), ["prevent"])),
              onKeyup: _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]), ["enter"]))
            }, null, 42, _hoisted_5), [
              [_vModelText, _ctx.trailerId]
            ]),
            (_ctx.trailerId || _ctx.hasAlert)
              ? (_openBlock(), _createElementBlock("label", _hoisted_6, [
                  _hoisted_7,
                  (_ctx.hasAlert)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, " - "))
                    : _createCommentVNode("", true),
                  (_ctx.hasAlert)
                    ? (_openBlock(), _createElementBlock("strong", {
                        key: 1,
                        class: _normalizeClass(_ctx.errorTextClass)
                      }, _toDisplayString(_ctx.errorText), 3))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_fbx_input_reset, {
              value: _ctx.trailerId,
              onResetValue: _ctx.onClear
            }, null, 8, ["value", "onResetValue"])
          ])
        ])
      ], 2),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          name: "typeToggle",
          class: "mobileToggle",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isInputText) = $event)),
          id: "typeToggle"
        }, null, 512), [
          [_vModelCheckbox, _ctx.isInputText]
        ]),
        _hoisted_10,
        _hoisted_11
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_fbx_button, {
          theme: "primary",
          "button-text": "Attach Trailer",
          disabled: _ctx.trailerId === '' || _ctx.hasAlert,
          onClick: _ctx.onSubmit
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_fbx_button, {
          disabled: !_ctx.scannerButtonEnabled,
          theme: _ctx.scannerButtonEnabled ? 'secondary' : 'primary',
          class: "italic",
          "button-text": `Scan QR`,
          onClick: _ctx.openScanner
        }, null, 8, ["disabled", "theme", "onClick"]),
        (_ctx.showCameraSettings)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createTextVNode(" QR scanner permissions are disabled "),
              _createElementVNode("strong", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onCameraSettingsClick && _ctx.onCameraSettingsClick(...args)))
              }, "Camera Settings")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}